export function addStringInString(str: string, index: number, stringToAdd: string): string {
	// in case index is undefined
	const indexToAddTo = index || str.length;
	return str.substring(0, indexToAddTo) + stringToAdd + str.substring(indexToAddTo, str.length);
}
